import React from "react";
import { Container } from "react-bootstrap";

const PitchOpex = () => {
  return (
    <>
      <section className="py-5">
        <Container>
          <p className="section-subtitle  text-start mb-2 px-3 pb-3">Opex</p>
          {/* first table */}
          <div className="scroll-x">
          <table className="custom-table">
            <thead>
              <tr>
                <th></th>
                <th>110%</th>
                <th>115%</th>
                <th>120%</th>
                <th>125%</th>
              </tr>
            </thead>
            <tbody>
              <tr className="active-dark">
                <td className="active">Year 01</td>
                <td>Unicorn</td>
                <td>Exceeding</td>
                <td>Meeting</td>
                <td>Performing</td>
                <td>Target</td>
              </tr>
              <tr>
                <td>Operating Exp</td>
                <td> $2,395,631,910</td>
                <td> $2,635,195,101</td>
                <td> $2,754,976,697</td>
                <td> $2,874,758,292</td>
                <td> $2,994,539,888</td>
              </tr>
              <tr>
                <td>Selling Exp</td>
                <td> $153,216,000</td>
                <td> $168,537,600</td>
                <td> $176,198,400</td>
                <td> $183,859,200</td>
                <td> $191,520,000</td>
              </tr>
              <tr>
                <td>Admin Exp</td>
                <td> $114,948,750</td>
                <td> $126,443,625</td>
                <td> $132,191,063</td>
                <td> $137,938,500</td>
                <td> $143,685,938</td>
              </tr>
              <tr>
                <td>Other Opex</td>
                <td> $-</td>
                <td> $-</td>
                <td> $-</td>
                <td> $-</td>
                <td> $-</td>
              </tr>
              <tr className="lead-row active-dark">
                <td>OPEX</td>
                <td> $2,663,796,660</td>
                <td> $2,930,176,326</td>
                <td> $3,063,366,159</td>
                <td> $3,196,555,992</td>
                <td> $3,329,745,825</td>
              </tr>
            </tbody>
          </table>
          </div>
          {/* second table */}
          
          <div className="py-5 scroll-x">
            <table className="custom-table">
              <tbody>
                <tr className="lead-row active-light">
                  <td className="only-cell active">Year 02</td>
                </tr>
                <tr>
                  <td>Operating Exp</td>
                  <td> $11,951,403,750</td>
                  <td> $13,146,544,125</td>
                  <td> $13,744,114,313</td>
                  <td> $14,341,684,500</td>
                  <td> $14,939,254,688</td>
                </tr>
                <tr>
                  <td>Selling Exp</td>
                  <td> $853,632,000</td>
                  <td> $938,995,200</td>
                  <td> $981,676,800</td>
                  <td> $1,024,358,400</td>
                  <td> $1,067,040,000</td>
                </tr>
                <tr>
                  <td>Admin Exp</td>
                  <td> $640,428,750</td>
                  <td> $704,471,625</td>
                  <td> $736,493,063</td>
                  <td> $768,514,500</td>
                  <td> $800,535,938</td>
                </tr>
                <tr>
                  <td>Other Opex</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                </tr>
                <tr className="lead-row active-dark">
                  <td>OPEX</td>
                  <td> $13,445,464,500</td>
                  <td> $14,790,010,950</td>
                  <td> $15,462,284,175</td>
                  <td> $16,134,557,400</td>
                  <td> $16,806,830,625</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* third table */}
          <div className="py-5 scroll-x">
            <table className="custom-table">
              <tbody>
                <tr className="lead-row active-light">
                  <td className="only-cell active">Year 03</td>
                </tr>
                <tr>
                  <td>Operating Exp</td>
                  <td> $25,951,712,400</td>
                  <td> $28,546,883,640</td>
                  <td> $29,844,469,260</td>
                  <td> $31,142,054,880</td>
                  <td> $32,439,640,500</td>
                </tr>
                <tr>
                  <td>Selling Exp</td>
                  <td> $1,996,185,600</td>
                  <td> $2,195,804,160</td>
                  <td> $2,295,613,440</td>
                  <td> $2,395,422,720</td>
                  <td> $2,495,232,000</td>
                </tr>
                <tr>
                  <td>Admin Exp</td>
                  <td> $1,497,618,000</td>
                  <td> $1,647,379,800</td>
                  <td> $1,722,260,700</td>
                  <td> $1,797,141,600</td>
                  <td> $1,872,022,500</td>
                </tr>
                <tr>
                  <td>Other Opex</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                </tr>
                <tr className="lead-row active-dark">
                  <td>OPEX</td>
                  <td> $29,445,516,000</td>
                  <td>  $ 32,390,067,600 </td>
                  <td> $33,862,343,400</td>
                  <td> $35,334,619,200</td>
                  <td> $36,806,895,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* fourth table */}
          <div className="py-5 scroll-x">
            <table className="custom-table">
              <tbody>
                <tr className="lead-row active-light">
                  <td className="only-cell active">Year 04</td>
                </tr>
                <tr>
                  <td>Operating Exp</td>
                  <td> $39,085,333,200</td>
                  <td> $42,993,866,520</td>
                  <td> $44,948,133,180</td>
                  <td> $46,902,399,840</td>
                  <td> $48,856,666,500</td>
                </tr>
                <tr>
                  <td>Selling Exp</td>
                  <td> $3,256,934,400</td>
                  <td> $3,582,627,840</td>
                  <td> $3,745,474,560</td>
                  <td> $3,908,321,280</td>
                  <td> $4,071,168,000</td>
                </tr>
                <tr>
                  <td>Admin Exp</td>
                  <td> $2,443,482,000</td>
                  <td> $2,687,830,200</td>
                  <td> $2,810,004,300</td>
                  <td> $2,932,178,400</td>
                  <td> $3,054,352,500</td>
                </tr>
                <tr>
                  <td>Other Opex</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                </tr>
                <tr className="lead-row active-dark">
                  <td>OPEX</td>
                  <td> $44,785,749,600</td>
                  <td> $49,264,324,560</td>
                  <td> $51,503,612,040</td>
                  <td> $53,742,899,520</td>
                  <td> $55,982,187,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* fifth table */}
          <div className="py-5 scroll-x">
            <table className="custom-table">
              <tbody>
                <tr className="lead-row active-light">
                  <td className="only-cell active">Year 05</td>
                </tr>
                <tr>
                  <td>Operating Exp</td>
                  <td> $39,085,333,200</td>
                  <td> $42,993,866,520</td>
                  <td> $44,948,133,180</td>
                  <td> $46,902,399,840</td>
                  <td> $48,856,666,500</td>
                </tr>
                <tr>
                  <td>Selling Exp</td>
                  <td> $3,256,934,400</td>
                  <td> $3,582,627,840</td>
                  <td> $3,745,474,560</td>
                  <td> $3,908,321,280</td>
                  <td> $4,071,168,000</td>
                </tr>
                <tr>
                  <td>Admin Exp</td>
                  <td> $2,443,482,000</td>
                  <td> $2,687,830,200</td>
                  <td> $2,810,004,300</td>
                  <td> $2,932,178,400</td>
                  <td> $3,054,352,500</td>
                </tr>
                <tr>
                  <td>Other Opex</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                  <td> $-</td>
                </tr>
                <tr className="lead-row active-dark">
                  <td>OPEX</td>
                  <td> $44,785,749,600</td>
                  <td> $49,264,324,560</td>
                  <td> $51,503,612,040</td>
                  <td> $53,742,899,520</td>
                  <td> $55,982,187,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* sixth table */}
          <div className="py-5 scroll-x">
            <table className="custom-table">
              <tbody>
                <tr className="lead-row active-light">
                  <td className="only-cell active">Operating Expenses:</td>
                </tr>
                <tr>
                  <td>Operating Exp</td>
                   	  	  	  	 
                  <td> $ 2,395,631,910 </td>
                  <td> $ 11,951,403,750 </td>
                  <td> $ 25,951,712,400 </td>
                  <td> $ 39,085,333,200 </td>
                  <td> $ 39,085,333,200 </td>
                </tr>
                <tr>
                  <td>Selling Exp</td>
                  	 	 	  	  
                  <td>$ 153,216,000 </td>
                  <td> $ 853,632,000</td>
                  <td>$ 1,996,185,600 </td>
                  <td>$ 3,256,934,400</td>
                  <td>$ 3,256,934,400</td>
                </tr>
                <tr>
                  <td>Admin Exp</td>
                  	  	  	  	 
                  <td> $ 114,948,750</td>
                  <td>$ 640,428,750</td>
                  <td>$ 1,497,618,000</td>
                  <td>$ 2,443,482,000</td>
                  <td> $ 2,443,482,000</td>
                </tr>
                <tr>
                  <td>Other Opex</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr className="lead-row active-dark">
                  <td>Operating Expense</td>
                  	  	  	  	 
                  <td>$ 2,663,796,660 </td>
                  <td>$ 13,445,464,500</td>
                  <td>$ 29,445,516,000</td>
                  <td>$ 44,785,749,600</td>
                  <td>$ 44,785,749,600 </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchOpex;
